var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStars = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 95,
  height: 55,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#stars_svg__a)",
  d: "M91 14.149c.078 0 .146.05.173.124a2.87 2.87 0 0 0 1.703 1.703.19.19 0 0 1 .124.173c0 .078-.05.146-.124.173a2.87 2.87 0 0 0-1.703 1.703.19.19 0 0 1-.173.124.19.19 0 0 1-.173-.124 2.87 2.87 0 0 0-1.703-1.703.19.19 0 0 1-.124-.173c0-.078.05-.146.124-.173a2.87 2.87 0 0 0 1.703-1.703.19.19 0 0 1 .173-.124"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#stars_svg__b)",
  d: "M85 31.149c.039 0 .073.025.087.062.144.394.457.707.851.852a.09.09 0 0 1 .062.086.09.09 0 0 1-.062.086 1.43 1.43 0 0 0-.852.852.09.09 0 0 1-.086.062.09.09 0 0 1-.087-.062 1.43 1.43 0 0 0-.851-.852.09.09 0 0 1-.062-.086c0-.039.025-.073.062-.087.394-.144.707-.457.852-.851a.09.09 0 0 1 .086-.062"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#stars_svg__c)",
  d: "M14 52.149c.039 0 .073.025.086.062.145.394.458.707.852.852a.09.09 0 0 1 .062.086.09.09 0 0 1-.062.086 1.43 1.43 0 0 0-.852.852.09.09 0 0 1-.086.062.09.09 0 0 1-.086-.062 1.43 1.43 0 0 0-.852-.852.09.09 0 0 1-.062-.086c0-.039.025-.073.062-.087.394-.144.707-.457.852-.851a.09.09 0 0 1 .086-.062"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#stars_svg__d)",
  d: "M4 42.149c.156 0 .292.102.346.248a5.73 5.73 0 0 0 3.406 3.406c.146.053.248.19.248.346a.37.37 0 0 1-.248.346A5.73 5.73 0 0 0 4.346 49.9.37.37 0 0 1 4 50.15a.37.37 0 0 1-.346-.248 5.73 5.73 0 0 0-3.406-3.406.37.37 0 0 1-.248-.346c0-.156.102-.293.248-.346a5.73 5.73 0 0 0 3.406-3.406.37.37 0 0 1 .346-.248"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#stars_svg__e)",
  d: "M5.5 26.149a.14.14 0 0 1 .13.093 2.15 2.15 0 0 0 1.277 1.277.14.14 0 0 1 .093.13.14.14 0 0 1-.093.13 2.15 2.15 0 0 0-1.277 1.277.14.14 0 0 1-.13.093.14.14 0 0 1-.13-.093 2.15 2.15 0 0 0-1.277-1.277.14.14 0 0 1-.093-.13.14.14 0 0 1 .093-.13 2.15 2.15 0 0 0 1.277-1.277.14.14 0 0 1 .13-.093"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#stars_svg__f)",
  d: "M84.5 1.149a.14.14 0 0 1 .13.093 2.15 2.15 0 0 0 1.277 1.277.14.14 0 0 1 .093.13.14.14 0 0 1-.093.13 2.15 2.15 0 0 0-1.277 1.277.14.14 0 0 1-.13.093.14.14 0 0 1-.13-.093 2.15 2.15 0 0 0-1.277-1.277.14.14 0 0 1-.093-.13.14.14 0 0 1 .093-.13 2.15 2.15 0 0 0 1.277-1.277.14.14 0 0 1 .13-.093"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#stars_svg__g)",
  d: "M90 40.149c.195 0 .365.127.432.31a7.16 7.16 0 0 0 4.258 4.258c.183.066.31.237.31.432a.46.46 0 0 1-.31.432 7.16 7.16 0 0 0-4.258 4.258.465.465 0 0 1-.432.31.465.465 0 0 1-.432-.31 7.16 7.16 0 0 0-4.258-4.258.46.46 0 0 1-.31-.432c0-.195.127-.366.31-.432a7.16 7.16 0 0 0 4.258-4.258.465.465 0 0 1 .432-.31"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#stars_svg__h)",
  d: "M12 .149c.156.156.19.394.098.594-1 2.154-1 4.658 0 6.812.093.2.058.438-.098.594a.525.525 0 0 1-.594.098c-2.154-1-4.658-1-6.812 0A.53.53 0 0 1 4 8.149a.53.53 0 0 1-.098-.594c1-2.154 1-4.658 0-6.812A.53.53 0 0 1 4 .149.53.53 0 0 1 4.594.05c2.154 1 4.658 1 6.812 0A.53.53 0 0 1 12 .149"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "stars_svg__a",
  x1: 91.306,
  x2: 88.68,
  y1: 13.165,
  y2: 13.324,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EBB446"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#AA641A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "stars_svg__b",
  x1: 85.153,
  x2: 83.84,
  y1: 30.657,
  y2: 30.736,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EBB446"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#AA641A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "stars_svg__c",
  x1: 14.153,
  x2: 12.84,
  y1: 51.657,
  y2: 51.736,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EBB446"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#AA641A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "stars_svg__d",
  x1: 4.611,
  x2: -0.641,
  y1: 40.181,
  y2: 40.499,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EBB446"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#AA641A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "stars_svg__e",
  x1: 5.729,
  x2: 3.76,
  y1: 25.411,
  y2: 25.53,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EBB446"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#AA641A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "stars_svg__f",
  x1: 84.729,
  x2: 82.76,
  y1: 0.411,
  y2: 0.53,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EBB446"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#AA641A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "stars_svg__g",
  x1: 90.764,
  x2: 84.199,
  y1: 37.689,
  y2: 38.086,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EBB446"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#AA641A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "stars_svg__h",
  x1: 8.634,
  x2: 3.187,
  y1: -2.041,
  y2: -1.711,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EBB446"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#AA641A"
})))));
export { SvgStars as ReactComponent };
export default __webpack_public_path__ + "../icons/1c80e26758c16e93226bdbed80b2d833.svg";